import { deleteApi, getApi, getApiCSV, getApiExcel, postApi, putApi } from 'apis';

const createEmployee = async (data: any) => {
	return await postApi('/employee', data);
};
const getEmployeeDetailsById = async (id: string) => {
	return await getApi(`/employee/${id}`);
};

const getEmployeeActivityData = async (parmas: any) => {
	return await getApi(`/activity`, parmas);
};

const updateEmployee = async (employeeId: string, data: any) => {
	return await putApi(`/employee/${employeeId}`, data);
};

const getEmployeeMasterEarnings = async (data: any) => {
	return await getApi('/employee/master-earnings', data);
};

const createEmployeeMasterEarnings = async (data: any) => {
	return await postApi('/employee/master-earnings', data);
};

const getEmployeeMasterDeductions = async (data: any) => {
	return await getApi('/employee/master-deductions', data);
};

const createEmployeeMasterDeductions = async (data: any) => {
	return await postApi('/employee/master-deductions', data);
};

const uploadEmployeeDocument = async (data: any) => {
	return await postApi('/employee/upload-docs', data, true);
};

const fetchEmployeeDocuments = async (employeeId: string) => {
	return await getApi(`/employee/docs/${employeeId}`);
};

const fetchBranchWiseEmployees = async () => {
	return await getApi('/employee/branch-wise-options');
};

const deleteEmployee = async (employeeId: any) => {
	return await deleteApi(`/employee/delete/${employeeId}`);
};

const importEmployees = async (data: any) => {
	return await postApi('/csv/employee-import', data);
};

const importEmployeesWithFormData = async (data: any) => {
	return await postApi('/csv/employee-import', data, true);
};

const importSalaryDetails = async (data: any, payPeriodId: string) => {
	return await postApi(
		`/csv/salary-import?payPeriodId=${payPeriodId}`,
		data,
		true
	);
};

const validateDataFromAPI = async (data: any) => {
	// Use unified endpoint that handles both CSV and Excel
	return await postApi('/csv/employee-upload', data, true);
};

const validateDataFromAPIForSalary = async (data: any, payPeriodId: string) => {
	return await postApi(
		`/csv/salary-upload?payPeriodId=${payPeriodId}`,
		data,
		true
	);
};

const downloadSalaryCsvTemplate = async () => {
	return await getApiExcel('/csv/salary-download');
};

const downloadEmployeeCsvTemplate = async () => {
	return await getApiExcel('/csv/employee-download');
};

const downloadEmployeeCsvWithDataTemplate = async (query: {
	status: string;
	staffCode:string;
	branchIds:string[];
}) => {
	return await getApiCSV('/csv/all-employees', query);
};

const downloadUploadHistoryReport = async (id: string) => {
	return await getApiExcel(`/employee/upload-history/${id}/download`);
};

export const employeeApi = {
	createEmployee,
	getEmployeeDetailsById,
	getEmployeeActivityData,
	updateEmployee,
	uploadEmployeeDocument,
	fetchEmployeeDocuments,
	deleteEmployee,
	downloadSalaryCsvTemplate,
	downloadEmployeeCsvTemplate,
	validateDataFromAPI,
	importEmployees,
	importSalaryDetails,
	validateDataFromAPIForSalary,
	importEmployeesWithFormData,
	downloadEmployeeCsvWithDataTemplate,
	getEmployeeMasterEarnings,
	createEmployeeMasterEarnings,
	createEmployeeMasterDeductions,
	getEmployeeMasterDeductions,
	fetchBranchWiseEmployees,
	downloadUploadHistoryReport,
};
